import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Button } from 'semantic-ui-react'
import { titleCase } from 'change-case'
import { MainBodyContent } from 'components'
import GeneralInformation from '../Form/GeneralInformation'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import ReturnInformation from '../Form/ReturnInformation'
import CommentHistory from 'routes/BankGuarantee/Form/CommentHistory'
import { bgVendorRequestPath, bgVendorRequestEditPath, bgVendorRequestPrintFormPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { getBGRequestDetail, getWorkflow, clearFormData } from 'ducks/bankGuaranteeRequest'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import Approve from '../Form/Approve'
import { isNullOrEmpty } from 'core/utilities'
import { StatusTag } from '../../../styled'

const BgRequestDetail = (props) => {
  const { valueForm, change, bgRequest, workflow } = props

  useEffect(() => {
    const id = props.match.params.id || ''
    props.getBGRequestDetail(id)
    props.getWorkflow(id)
  }, [])

  useEffect(() => {
    if (valueForm.status === 5 && !isNullOrEmpty(valueForm.sn)) {
      props.clearFormData()
      props.history.push(bgVendorRequestEditPath(valueForm.id))
    }
  }, [valueForm.status])

  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Request Bank Guarantee - ${valueForm.documentNumber}`}
          <StatusTag status={valueForm.status} style={{ marginLeft: '10px' }}>{valueForm.statusName}</StatusTag>
        </React.Fragment>
      }
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          {
            valueForm.status === 4 || valueForm.status === 26 ?
            <Button
              basic
              circular
              type='button'
              content='BG Form'
              labelPosition='right'
              icon='print'
              onClick={() => (window.open(bgVendorRequestPrintFormPath(valueForm.id)))} /> : null
          }
        </div>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Request Change/Return', link: true, onClick: () => props.history.push(bgVendorRequestPath) },
              { key: 'BGEdit', content: 'Request Detail', active: true }
            ]
          }
        />
      }
    >
      <DocumentStep documentDetail={bgRequest} approvers={workflow.data} />
      <form>
        <DocumentTypeContent>Request for : {titleCase(valueForm.requestType)}</DocumentTypeContent>
        <BankGuaranteeInformation valueForm={valueForm} isDisplay change={change} />
        <GeneralInformation valueForm={valueForm} isDisplay />
        <Approve handleSubmit={props.handleSubmit} history={props.history} />
        <VendorContact isDisplay />
        <Attachment valueForm={valueForm} isDisplay />
        <ReturnInformation valueForm={valueForm} isDisplay />
        <CommentHistory comments={valueForm.comments} attachment={[...(valueForm.attachment03 || []), ...(valueForm.attachment05 || [])]} />
      </form>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const vf = getFormValues('formBGRequest')(state) || {}

  return ({
    valueForm: vf,
    bgRequest: state.bgRequest.bgRequest.data,
    workflow: state.bgRequest.workflow,
    initialValues: {
      ...state.bgRequest.bgRequest.data
    },
  })
}

const mapDispatchToProps = {
  getBGRequestDetail,
  getWorkflow,
  clearFormData
}

const BgRequestDetailForm = reduxForm({
  form: 'formBGRequest',
  enableReinitialize: true
})(BgRequestDetail)

export default connect(mapStateToProps, mapDispatchToProps)(BgRequestDetailForm)